export default "__VITE_ASSET__wkVEyass__"